import braOption1 from "/public/Images/Option1Bandpullsfar.gif";
import braOption2 from "/public/Images/Option2Bandpullsokay.gif";
import braOption3 from "/public/Images/Option3Bandlooksgood.gif";

// bf1
export const bf1 = [
  {
    id: 1,
    type: "prompt",
    content:
      "A correctly fitted and firmer band size is the secret to a lifted look. The quickest fix is to try to go down 1 band size from your current band size. For example, if you’re currently wearing a 90C, try an 85D. I can assist with sizing conversion if you provide your current bra size. Alternatively, if you'd like more personalized and detailed troubleshooting to improve the lift, just let me know!",
    options: [
      { label: "Yes", next: 2 },
      { label: "No", next: 8 },
    ],
    next: 2,
  },
  {
    id: 2,
    type: "prompt",
    content:
      "Please grab your most-fitted bra in band-cup size, preferably a wired bra (e.g., 80D, 90C). The newer the bra, the better. \n When you’re ready - let me know!",
    options: [{ label: "I'm ready.", next: 3 }],
    next: 3,
  },
  {
    id: 3,
    type: "braSizeInput",
    content: "Enter your current bra size:",
    next: 4,
  },
  {
    id: 4,
    type: "promptWithImages",
    content:
      "Let’s start - Wear the bra on the loosest hook, then use your fingers to pull the bra away from your body, and lift your arms. Which video resonates with you the most?",
    options: [
      {
        label: "Significant pull & cup moves",
        image: braOption1,
        next: 5,
      },
      {
        label: "Moderate pull",
        image: braOption2,
        next: 6,
      },
      {
        label: "Correct Fit",
        image: braOption3,
        next: 7,
      },
    ],
  },
  {
    id: 5,
    type: "result",
    content:
      "I suggest you drop two band sizes from your usual size. Most women wear 2 band sizes too large for their frame, so this is completely normal.",
    options: [{ label: "[Display Best-Selling Products]" }],
  },
  {
    id: 6,
    type: "result",
    content: "I suggest you drop one band size from your usual size.",
    options: [{ label: "[Display Best-Selling Products]" }],
  },
  {
    id: 7,
    type: "result",
    content:
      "It appears that you’re wearing the correct band size for yourself. This is great! I’d advise you to try the following tips: \n Tighten the straps gently. You should be able to run two fingers underneath comfortably, or you can cross the straps over or create a J-hook. \n Scoop the Breasts: Lean forward and move the side breasts to the center \n Explore T-shirt bras with cleavage-enhancing padding or bras with vertical seams for gentle uplift. Avoid bras with horizontal seams.",
    options: [{ label: "[Display Best-Selling Products]" }],
  },
  {
    id: 8,
    type: "result",
    content:
      "If you need anything else, let me know!",
  },
];
